import Component from 'vue-class-component';
import { AppVue } from '../../app.vue';
import { AppNet } from '../../app.net';
import { Carousel3d, Slide } from 'vue-carousel-3d'
import './home.scss';

@Component({
    template: require('./home.html'),
    components: {
    },
    props: {},
})

export class PageHome extends AppVue {
    jump(url) {
        // sessionStorage.setItem('pg','1');
        this.hrefTo(url);
    }


    menu = {
        home: 'true',
        liebiao: 'false'
    }
    mounted() {

    }

    ScWidth: number

    created() {
        this.ScWidth = screen.width
        console.log('宽'+screen.width)
    }


    itemlist = [
        {
            src: require('@/' + '/assets/open/CompositionPlatform.png'), title: '数字权益SaaS服务聚合平台', body: '常客云开放平台是常客云数字权益SaaS服务聚合平台。平台通过聚合数字权益生态的各方资源，' +
                '为企业提供丰富的数字化权益、产品及服务，帮助所有客户实现可持续的商业增长。'
        },
        {
            src: require('@/' + '/assets/open/RightsConvenience.png'), title: 'AI收银台', body: 'AI收银台，为零售企业店铺提供从供应商供货到配送中心，再到门店管理，提供了线上线下一体' +
                '化解决方案，帮助零售企业实现全渠道营销'
        },
        { src: require('@/' + '/assets/open/cashierDesk.png'), title: '权益便利', body: '基于常客云的线上、线下场景产品，为用户提供各发行机构权益兑换服务。' }
    ]

    telPrcList = [
        {
            src: require('@/' + '/assets/h5icon/CompositionPlatform.png')
        },
        {
            src: require('@/' + '/assets/h5icon/RightsConvenience.png')
        },
        { src: require('@/' + '/assets/h5icon/cashierDesk.png') }
    ]

}


